"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NudgeIcon;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function NudgeIcon(_ref) {
  var variant = _ref.variant;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, variant === '1' && /*#__PURE__*/_react["default"].createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "#C0FFE2"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.7352 4H12.991H11.2028L9.99488 11.4678C9.96925 11.4706 9.94362 11.473 9.91751 11.4764C7.24874 11.8283 5.17718 14.0556 5.20039 16.5476C5.21006 17.5895 5.56934 18.4033 6.21151 19.0702C6.79178 19.673 7.58337 20 8.38172 20C8.6941 20 9.00745 19.9501 9.30967 19.847C10.7487 19.356 11.2255 18.1587 11.4499 17.0626C11.4494 17.064 11.4494 17.0655 11.4489 17.0664C11.5137 15.8432 10.8546 14.6358 9.59787 13.9204L9.20039 16.41C9.07273 17.1163 8.90687 17.5387 8.55049 17.66C8.3382 17.7324 8.07563 17.6576 7.89816 17.4735C7.66992 17.2362 7.53646 16.972 7.53211 16.526C7.5205 15.2807 8.50745 14.3035 9.59787 13.9209C9.93975 13.7986 10.2956 13.7406 10.6936 13.7406C11.0969 13.7406 11.5224 13.8178 11.9098 13.9463C11.9098 13.9463 11.9098 13.9463 11.9098 13.9468C11.9098 13.9468 11.9098 13.9468 11.9098 13.9463C13.3817 14.2906 14.2739 15.8394 14.4949 17.5157L14.6245 18.455H17.0732L14.7352 4ZM12.2236 11.6289L12.9257 6.28482H12.947H13.0123L13.7961 12.2489C13.299 11.9789 12.7691 11.7684 12.2236 11.6289Z",
    fill: "#003359"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.4502 17.0661C11.5735 16.5429 11.8598 14.5367 11.9105 13.9459C11.5232 13.8174 11.0977 13.7402 10.6944 13.7402C10.2969 13.7402 9.94051 13.7983 9.59863 13.9205C10.8559 14.6355 11.515 15.8428 11.4502 17.0661Z",
    fill: "#282827"
  })), variant === '2' && /*#__PURE__*/_react["default"].createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "12",
    fill: "#8CF4BE"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0_1231_5181)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.3786 8.95237C10.4926 8.7075 10.8407 8.7075 10.9547 8.95237L11.7163 10.5885C12.0195 11.24 12.5346 11.7695 13.1775 12.0905L14.764 12.8826C14.9984 12.9996 14.9984 13.3341 14.764 13.4511L13.1775 14.2432C12.5346 14.5642 12.0195 15.0937 11.7163 15.7451L10.9547 17.3813C10.8407 17.6262 10.4926 17.6262 10.3786 17.3813L9.61706 15.7451C9.31383 15.0937 8.79872 14.5642 8.15582 14.2432L6.56934 13.4511C6.33495 13.3341 6.33495 12.9996 6.56934 12.8826L8.15582 12.0905C8.79872 11.7695 9.31383 11.24 9.61706 10.5885L10.3786 8.95237Z",
    fill: "#282827"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.5146 6.33733C15.5734 6.20647 15.7592 6.20647 15.8181 6.33733L16.1871 7.15742C16.3413 7.50023 16.6071 7.78073 16.9411 7.95324L17.7134 8.35213C17.8335 8.41415 17.8335 8.58585 17.7134 8.64787L16.9411 9.04676C16.6071 9.21927 16.3413 9.49977 16.1871 9.84258L15.8181 10.6627C15.7592 10.7935 15.5734 10.7935 15.5146 10.6627L15.1456 9.84258C14.9913 9.49977 14.7256 9.21927 14.3916 9.04676L13.6193 8.64787C13.4992 8.58585 13.4992 8.41415 13.6193 8.35213L14.3916 7.95324C14.7256 7.78073 14.9913 7.50023 15.1456 7.15742L15.5146 6.33733Z",
    fill: "#282827"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0_1231_5181"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "12",
    height: "12",
    fill: "white",
    transform: "translate(6 6)"
  })))), variant === '3' && /*#__PURE__*/_react["default"].createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: "timer",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "24",
    height: "24",
    rx: "12",
    fill: "#8CF4BE"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.2504 12C20.2504 15.0651 17.7656 17.55 14.7004 17.55C11.6352 17.55 9.15039 15.0651 9.15039 12C9.15039 8.93477 11.6352 6.44995 14.7004 6.44995C17.7656 6.44995 20.2504 8.93477 20.2504 12Z",
    stroke: "#282827",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.6992 10.2V12.45H16.9492",
    stroke: "#282827",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.90039 12H6.60039",
    stroke: "#282827",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.69922 14.7H7.49922",
    stroke: "#282827",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.80078 9.30005H7.50078",
    stroke: "#282827",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
NudgeIcon.propTypes = {
  variant: _propTypes["default"].arrayOf(_propTypes["default"].oneOf(['1', '2', '3']))
};
NudgeIcon.defaultProps = {
  variant: '1'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/assets/nudge-icon.js
// module id = 2725
// module chunks = 25